import React from 'react'
import Header from './components/Header'
import Search from './components/Search'


const App = () => {




    return (

        <div className="main">
           <div className="container">

                <Header />
                <Search />

            </div>
            </div>
        
    )
}


export default App;